import { useTranslation } from "react-i18next";

import { Container, Label, LabelContainer } from "./styles";
import { Radio } from "../radio";
import { IOnboardingChoices } from "~/types/account";
import { Dispatch, SetStateAction } from "react";
import { useMediaQuery } from "~/hooks/useMediaQuery";

export const WORDS = [
  {
    id: "modern",
    label: "onboarding.customization-store.described-word.modern",
  },
  {
    id: "innovative",
    label: "onboarding.customization-store.described-word.innovative",
  },
  {
    id: "artistic",
    label: "onboarding.customization-store.described-word.artistic",
  },
  {
    id: "luxurious",
    label: "onboarding.customization-store.described-word.luxurious",
  },
];

type ColorSchemeProps = {
  onboardingChoices: IOnboardingChoices | undefined;
  setOnboardingChoices: Dispatch<
    SetStateAction<IOnboardingChoices | undefined>
  >;
};

export const DescribedWord = ({
  onboardingChoices,
  setOnboardingChoices,
}: ColorSchemeProps) => {
  const { t } = useTranslation();
  const isAboveMobile = useMediaQuery("mobileL");

  const handleSelectDescribedWord = (word: string) => {
    setOnboardingChoices((prev) => ({
      ...prev,
      selectedBestDescribedWord: word,
    }));
  };

  return (
    <Container data-testid="onboarding-described-word">
      {WORDS.map((colorScheme) => {
        const { id, label } = colorScheme;
        const checked = id === onboardingChoices?.selectedBestDescribedWord;

        return (
          <Radio
            context="described-word-selection"
            key={`store-described-word-selection-${id}`}
            optionId={id}
            checked={checked}
            label={t(label)}
            changeSeletedOption={handleSelectDescribedWord}
            hasUniqueLabel
            isFullWidth={!isAboveMobile}
            uniqueLabel={
              <LabelContainer>
                <Label checked={checked}>{t(label)}</Label>
              </LabelContainer>
            }
          />
        );
      })}
    </Container>
  );
};
